import React, { Component } from "react";
import { Divider, Row, Layout, Button, Popover, Icon, message } from "antd";
import "../../App.css";
import CompareTable from "../table/CompareTable";
// import Filter from "../filter/Filter.js";
import HotTags from "../tag/Tag.js";
import SearchBar from "../autocomplete/SearchBar";
import axios from "axios";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import ReactGA from "react-ga4";
// import Popup from "../multiplecats/Modal.js";
import version from "./version";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import { Helmet, HelmetProvider } from "react-helmet-async";
import VenatusAd from "../../components/ads/VenatusAd";
import {
  VENATUS_DESKTOP_SIDE_RAIL,
  VENATUS_DESKTOP_MULTISIZE_LEADERBOARD,
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_DESKTOP_INCONTENT,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_MOBILE_STICKY_FOOTER,
  VENATUS_RICH_MEDIA,
} from "../../components/utilities/constants";

const { Sider, Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class CompareCats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCatsKR: [],
      viewportHeight: 0,
      compareCatsLevelsKR: 30,
      copied: false,
    };

    this.hydrateStateWithLocalStorage =
      this.hydrateStateWithLocalStorage.bind(this);
  }

  myCallbackToSearchbar = (dataFromSearchbar) => {
    const catAlreadySelected = this.state.selectedCatsKR.some((el) => {
      return el.name === dataFromSearchbar;
    });
    const compareCatsLevelsKR = this.state.compareCatsLevelsKR;

    if (!catAlreadySelected) {
      axios
        .post("https://onestoppress.com/api/singlecatkr", {
          compare: dataFromSearchbar,
        })
        .then((res) => {
          let dataSource = res.data.sampledata;
          // console.log("searchbar: " + dataSource);
          // dataSource.key = index;
          dataSource.level2 = compareCatsLevelsKR;
          dataSource.key = this.state.selectedCatsKR.length;

          // console.log(dataSource);
          this.setState((prevState) => ({
            selectedCatsKR: [...prevState.selectedCatsKR, dataSource],
          }));
          // console.log(this.state.selectedCatsKR);
        });
    }
  };

  hydrateStateWithLocalStorage() {
    // for all items in state
    for (let key in this.state) {
      // if the key exists in localStorage
      if (localStorage.hasOwnProperty(key)) {
        // get the key's value from localStorage
        let value = localStorage.getItem(key);
        // console.log(key, value);
        try {
          value = JSON.parse(value);
          if (key === "selectedCatsKR") {
            let selectedCatsKR = value.map(function (cat, index) {
              var o = Object.assign({}, cat);
              o.key = index;
              // console.log(o);
              if (o.ability === null) {
                o.ability = " ";
              }
              return o;
            });

            this.setState({ selectedCatsKR: selectedCatsKR });
          } else {
            this.setState({ [key]: value }, function () {
              // console.log(this.state);
            });
          }
        } catch (e) {
          // handle empty string
          this.setState({ [key]: value });
        }
      }
    }
  }

  componentDidMount() {
    if (window.location.search === "") {
      this.hydrateStateWithLocalStorage();
    } else {
      this.hydrateStateWithLocalStorage();

      axios
        .post("https://onestoppress.com/api/multiplecatskr", {
          compare: window.location.search,
        })
        .then((res) => {
          let dataSource = res.data.sampledata;

          let selectedCatsKR = dataSource.map(function (cat, index) {
            var o = Object.assign({}, cat);
            o.key = index;
            o.level2 = o.lvl2 ? o.lvl2 : 30;
            if (o.ability === null) {
              o.ability = " ";
            }
            return o;
          });

          this.setState({ selectedCatsKR: selectedCatsKR });
        });
    }
    // console.log(this.state.selectedCatsKR);

    // add event listener to save state to localStorage
    // when user leaves/refreshes the page
    document.title = "냥코 비교하기 | My Gamatoto | 냥코 대전쟁 위키: 냥코 스탯";

    window.addEventListener(
      "beforeunload",
      this.saveStateToLocalStorage.bind(this)
    );

    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();
  }

  saveStateToLocalStorage() {
    // for every item in React state
    for (let key in this.state) {
      // save to localStorage
      localStorage.setItem(key, JSON.stringify(this.state[key]));
    }
  }

  componentWillUnmount() {
    window.removeEventListener(
      "beforeunload",
      this.saveStateToLocalStorage.bind(this)
    );

    // saves if component has a chance to unmount
    this.saveStateToLocalStorage();

    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 768) {
      adjustViewport = 135;
    } else {
      adjustViewport = 290;
    }

    this.setState({
      viewportHeight: window.innerHeight - adjustViewport,
    });
  }, this.props.applyViewportChange);

  myCallbackToTable = (key) => {
    this.setState({
      selectedCatsKR: this.state.selectedCatsKR.filter(
        (item) => item.key !== key
      ),
    });
  };

  // myCallbackToPopup = (finalselectedCatsKR) => {
  //   let currentCatLevels = this.state.compareCatsLevelsKR;
  //   finalselectedCatsKR = finalselectedCatsKR.map(function (cat, index) {
  //     var o = Object.assign({}, cat);
  //     o.key = index;
  //     o.level2 = currentCatLevels;
  //     return o;
  //   });
  //   this.setState({ selectedCatsKR: finalselectedCatsKR });
  // };

  myFormCallbackToTable = (number, level2, key) => {
    // Replace cat with its next form
    // console.log(number, level2);
    // console.log(key);
    axios
      .post("https://onestoppress.com/api/nextcatkr", {
        cat_no_req: number,
      })
      .then((res) => {
        // console.log(number);
        let nextForm = res.data.sampledata;
        nextForm.level2 = level2;
        nextForm.key = key;

        var o = this.state.selectedCatsKR.slice();
        // var catindex = o.indexOf(record);
        // o[catindex] = nextForm;
        o[key] = nextForm;

        this.setState({ selectedCatsKR: o });
      })
      .catch((err) => console.log("err: ", err));
  };

  myEditableCallbackToTable = (newData) => {
    // Update parent state with new level of cat whenever user types it
    this.setState({
      selectedCatsKR: newData,
    });
  };

  levelPresetCallbackToTable = (compareCatsLevelsKR) => {
    let dataSource = this.state.selectedCatsKR.map(function (cat) {
      cat.level2 = compareCatsLevelsKR;
      return cat;
    });

    this.setState({
      selectedCatsKR: dataSource,
      compareCatsLevelsKR: compareCatsLevelsKR,
    });
  };

  // to print out the state whenever it updates
  componentDidUpdate(prevState) {
    if (prevState.selectedCatsKR !== this.state.selectedCatsKR) {
      let nextURL = "/?";
      // this.state.selectedCatsKR.forEach((cat) => {
      //   nextURL +=
      //     "cat=" +
      //     cat.name
      //       .replaceAll(" ", "-")
      //       .replaceAll(".", "")
      //       .replaceAll("'", "") +
      //     "-Lvl" +
      //     cat.level2 +
      //     "&";
      // });

      this.state.selectedCatsKR.forEach((cat) => {
        nextURL += "cat=" + cat.number + "-Lvl" + cat.level2 + "&";
      });

      // console.log(this.state.selectedCatsKR);
      // const nextState = { additionalInformation: 'Updated the URL with JS' }
      const currentURL = "/kr/comparecats";
      const nextTitle =
        "냥코 비교하기 | My Gamatoto | 냥코 대전쟁 위키: 냥코 스탯";

      window.history.replaceState(
        "",
        nextTitle,
        currentURL + nextURL.substring(0, nextURL.length - 1)
      );
    }
  }

  onButtonClick(e) {
    this.setState({
      selectedCatsKR: [],
    });
  }

  render() {
    const copy = async () => {
      await navigator.clipboard.writeText(window.location.href);
      message.success("Copied!");
      // alert("Copied to clipboard: " + window.location.href);
    };

    return (
      <div>
        <Helmet>
          <link rel="canonical" href="http://mygamatoto.com/comparecats" />
        </Helmet>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              float: "left",
            }}
          >
            냥코 비교하기
          </h1>
          <div style={{ paddingTop: "10px" }}>
            <Popover
              content={<div>Updated to BattleCats Version {version}</div>}
              placement="bottomRight"
            >
              <Icon type="info-circle" />
            </Popover>
          </div>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>

        <Layout>
          <Sider
            width={220}
            className="sider filter"
            style={{
              padding: "0 12px 0 12px",
              background: "white",
              display: "none",
            }}
          >
            <HotTags />
          </Sider>
          <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
            <Content style={{ padding: "0 0px" }}>
              <Row style={{ padding: "12px 0 8px 0" }}>
                {/* <Popup callbackFromParent={this.myCallbackToPopup.bind(this)} /> */}
                <Button
                  onClick={this.onButtonClick.bind(this)}
                  style={{
                    float: "right",
                    marginLeft: "6px",
                  }}
                >
                  모두 삭제
                </Button>
                <SearchBar
                  callbackFromParent={this.myCallbackToSearchbar.bind(this)}
                />
                <div style={{ float: "left" }} className="forsharing">
                  <Button
                    onClick={copy}
                    style={{ marginRight: "0.25rem", float: "left" }}
                  >
                    클립보드에 복사
                  </Button>

                  {/* <FacebookShareButton
                    url={
                      "http://mygamatoto.com" +
                      window.location.pathname +
                      window.location.search
                    }
                    style={{
                      marginRight: "0.25rem",
                    }}
                  >
                    <FacebookIcon size={32} round />
                  </FacebookShareButton> */}
                  <TwitterShareButton
                    url={
                      "http://mygamatoto.com" +
                      window.location.pathname +
                      window.location.search
                    }
                    title="MyGamatoto - Compare Cats List"
                    style={{ marginRight: "0.25rem" }}
                  >
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                  <RedditShareButton
                    url={
                      "http://mygamatoto.com" +
                      window.location.pathname +
                      window.location.search
                    }
                    style={{ marginRight: "0.25rem" }}
                  >
                    <RedditIcon size={32} round />
                  </RedditShareButton>
                  <VKShareButton
                    url={
                      "http://mygamatoto.com" +
                      window.location.pathname +
                      window.location.search
                    }
                    title="MyGamatoto - Compare Cats List"
                    style={{ marginRight: "0.25rem" }}
                  >
                    <VKIcon size={32} round />
                  </VKShareButton>
                </div>
              </Row>

              <Row style={{ padding: "0px 0 0px 0" }}>
                <CompareTable
                  selectedCatsKR={this.state.selectedCatsKR}
                  viewportHeight={this.state.viewportHeight}
                  callbackFromParent={this.myCallbackToTable.bind(this)}
                  formCallbackFromParent={this.myFormCallbackToTable.bind(this)}
                  editableCallbackFromParent={this.myEditableCallbackToTable.bind(
                    this
                  )}
                  levelCallbackFromParent={this.levelPresetCallbackToTable.bind(
                    this
                  )}
                  presetCatLevels={this.state.compareCatsLevelsKR}
                />
              </Row>
              <Row
                style={{
                  padding: "8px 0 8px 0",
                }}
              ></Row>
            </Content>
          </Layout>
        </Layout>
        <div>
          <VenatusAd
            placementId={VENATUS_RICH_MEDIA}
            style={{ display: "none" }}
          />
        </div>
        <div class="vm-placement" id="vm-av" data-format="isvideo"></div>
      </div>
    );
  }
}

export default CompareCats;

CompareCats.propTypes = {
  applyViewportChange: PropTypes.number,
};

CompareCats.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components-kr/content/CompareCats.js